import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LinguaProvider } from './context/LinguaContext';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorPage from './pages/ErrorPage';
import SignupCompletePage from './pages/SignupCompletePage';
// ── V2 — unica estetica ufficiale, servita su root ──
import V2Layout from './v2/components/Layout';
import V2HomePage from './v2/pages/HomePage';
import V2ComingSoon from './v2/pages/ComingSoonPage';
import {
  DaPagarePage as V2DaPagare, RinnovoPage as V2Rinnovo, FatturePage as V2Fatture,
  TransazioniPage as V2Transazioni, OrdiniPage as V2Ordini, MetodiPage as V2Metodi,
  ImpostazioniPage as V2ImpostazioniFatt,
} from './v2/pages/contabilita';
import {
  ImpostazioniAccountPage as V2AccHome, PasswordPage as V2AccPassword,
  AppPasswordPage as V2AccAppPwd, AccessoPage as V2AccAccesso,
  SicurezzaPage as V2AccSicurezza, Doppia2faPage as V2Acc2fa, SupportoAccountPage as V2AccSupporto,
  TokenPage as V2AccToken, CreateTokenPage as V2AccTokenNew,
  UtentiPage as V2AccUtenti, UtentiInvitaPage as V2AccUtentiNuovo, UtentiDettaglioPage as V2AccUtenteDett, GruppiPage as V2AccGruppi,
  RapportoAttivitaPage as V2AccRapporto,
} from './v2/pages/account';
import {
  OrganizzazionePage as V2SetOrg, OrganizzazioneModificaPage as V2SetOrgEdit, PersonalizzazionePage as V2SetPerso,
  ProdottiSettingsPage as V2SetProdotti, SicurezzaImpPage as V2SetSicurezza,
  EtichettaPage as V2SetEtichetta,
  CondizioniPage as V2SetCondizioni, ContrattiPage as V2SetContratti,
} from './v2/pages/impostazioni';
import V2Supporto from './v2/pages/support';
import {
  PostaCertificataPage as V2PecPosta, SpidPage as V2PecSpid,
  FirmaDigitalePage as V2PecFirma, FatturazioneElettronicaPage as V2PecFattura,
  MarcaTemporalePage as V2PecMarca,
} from './v2/pages/pec';
import {
  ServerDedicatiPage as V2CloudDedicati, VpsPage as V2CloudVps,
  StoragePage as V2CloudStorage, NasPage as V2CloudNas, HousingPage as V2CloudHousing,
  VpsDetailPage as V2CloudVpsDetail, DedicatedDetailPage as V2CloudDedicatedDetail,
} from './v2/pages/cloud';
import {
  SitiPage as V2HdSiti, HostingListPage as V2HdHosting,
  DominiPage as V2HdDomini, SslPage as V2HdSsl, HostingDetailPage as V2HdDetail,
  DomainDetailPage as V2HdDomainDetail,
} from './v2/pages/hosting';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <LinguaProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/errore" element={<ErrorPage />} />

          {/* Signup FUORI dal Layout — pagina standalone con solo logo */}
          <Route element={<ProtectedRoute />}>
            <Route path="/signup" element={<SignupCompletePage />} />
          </Route>

          {/* Compat: vecchi link /v2/* → radice */}
          <Route path="/v2/*" element={<Navigate to="/" replace />} />

          {/* ═══ Area cliente (V2, unica versione) — servita su radice ═══ */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<V2Layout />}>
              <Route index element={<V2HomePage />} />
              {/* ── Contabilità ── */}
              <Route path="billing" element={<Navigate to="/billing/da-pagare" replace />} />
              <Route path="billing/da-pagare" element={<V2DaPagare />} />
              <Route path="billing/rinnovo" element={<V2Rinnovo />} />
              <Route path="billing/fatture" element={<V2Fatture />} />
              <Route path="billing/transazioni" element={<V2Transazioni />} />
              <Route path="billing/ordini" element={<V2Ordini />} />
              <Route path="billing/metodi-pagamento" element={<V2Metodi />} />
              <Route path="billing/impostazioni" element={<V2ImpostazioniFatt />} />
              {/* ── Utenti e profilo ── */}
              <Route path="account/utenti" element={<V2AccUtenti />} />
              <Route path="account/utenti/aggiungi" element={<V2AccUtentiNuovo />} />
              <Route path="account/utenti/:id" element={<V2AccUtenteDett />} />
              <Route path="account/gruppi" element={<V2AccGruppi />} />
              <Route path="account/rapporto-attivita" element={<V2AccRapporto />} />
              <Route path="account" element={<V2AccHome />} />
              <Route path="account/password" element={<V2AccPassword />} />
              <Route path="account/app-password" element={<V2AccAppPwd />} />
              <Route path="account/accesso" element={<V2AccAccesso />} />
              <Route path="account/sicurezza" element={<V2AccSicurezza />} />
              <Route path="account/sicurezza/2fa" element={<V2Acc2fa />} />
              <Route path="account/supporto" element={<V2AccSupporto />} />
              <Route path="account/sviluppatore" element={<Navigate to="/account/sviluppatore/token" replace />} />
              <Route path="account/sviluppatore/token" element={<V2AccToken />} />
              <Route path="account/sviluppatore/token/nuovo" element={<V2AccTokenNew />} />
              {/* ── Impostazioni ── */}
              <Route path="settings" element={<V2SetOrg />} />
              <Route path="settings/organizzazione/modifica" element={<V2SetOrgEdit />} />
              <Route path="settings/personalizzazione" element={<V2SetPerso />} />
              <Route path="settings/prodotti" element={<V2SetProdotti />} />
              <Route path="settings/sicurezza" element={<V2SetSicurezza />} />
              <Route path="settings/etichette" element={<V2SetEtichetta />} />
              <Route path="settings/condizioni" element={<V2SetCondizioni />} />
              <Route path="settings/contratti" element={<V2SetContratti />} />
              <Route path="support" element={<V2Supporto />} />
              <Route path="partner" element={<V2ComingSoon title="Partner" />} />
              {/* ── Web & Domini (Dashboard con tab) ── */}
              <Route path="hosting-domains" element={<Navigate to="/hosting-domains/siti" replace />} />
              <Route path="hosting-domains/siti" element={<V2HdSiti />} />
              <Route path="hosting-domains/hosting" element={<V2HdHosting />} />
              <Route path="hosting-domains/hosting/:id" element={<V2HdDetail />} />
              <Route path="hosting-domains/hosting/:id/*" element={<V2ComingSoon title="Sezione hosting" />} />
              <Route path="hosting-domains/domains" element={<V2HdDomini />} />
              <Route path="hosting-domains/domains/:nome" element={<V2HdDomainDetail />} />
              <Route path="hosting-domains/ssl" element={<V2HdSsl />} />
              {/* ── PEC & Trust Services (Dashboard con tab) ── */}
              <Route path="pec-trust" element={<Navigate to="/pec-trust/posta-certificata" replace />} />
              <Route path="pec-trust/posta-certificata" element={<V2PecPosta />} />
              <Route path="pec-trust/spid" element={<V2PecSpid />} />
              <Route path="pec-trust/firma-digitale" element={<V2PecFirma />} />
              <Route path="pec-trust/fatturazione-elettronica" element={<V2PecFattura />} />
              <Route path="pec-trust/marca-temporale" element={<V2PecMarca />} />
              {/* ── Cloud e Server Dedicati (Dashboard con tab) ── */}
              <Route path="cloud-dedicated" element={<Navigate to="/cloud-dedicated/dedicated" replace />} />
              <Route path="cloud-dedicated/dedicated" element={<V2CloudDedicati />} />
              <Route path="cloud-dedicated/dedicated/:id" element={<V2CloudDedicatedDetail />} />
              <Route path="cloud-dedicated/vps" element={<V2CloudVps />} />
              <Route path="cloud-dedicated/vps/:id" element={<V2CloudVpsDetail />} />
              <Route path="cloud-dedicated/storage" element={<V2CloudStorage />} />
              <Route path="cloud-dedicated/nas" element={<V2CloudNas />} />
              <Route path="cloud-dedicated/housing" element={<V2CloudHousing />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      </LinguaProvider>
    </AuthProvider>
  );
}

export default App;
